export default "__VITE_ASSET__C8TqD8Ht__"